// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {DateTimePicker} from 'react-widgets'

import {FormFieldError} from './'

export default class DateTimePickerField extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false
    }
  }

    setDropdownVisibility = () => {
      const TIME_DROPDOWN = 'time'
      const DATE_DROPDOWN = 'date'

      if (this.props.time && this.props.date) {
        if (!this.state.open) {
          this.setState({open: DATE_DROPDOWN})
        }

        if (this.state.open === DATE_DROPDOWN) {
          this.setState({open: TIME_DROPDOWN})
        }

        if (this.state.open === TIME_DROPDOWN) {
          this.setState({open: false})
        }
      } else if (this.props.time) {
        !this.state.open ? this.setState({open: TIME_DROPDOWN}) : this.setState({open: false})
      } else if (this.props.date) {
        !this.state.open ? this.setState({open: DATE_DROPDOWN}) : this.setState({open: false})
      }
    }

    render () {
      return (
        <FormFieldError {...this.props}>
          <DateTimePicker
            {...this.props.min || null}
            {...this.props.max || null}
            id={this.props.name}
            timeIcon={this.props.timeIcon}
            dateIcon={this.props.dateIcon}
            date={this.props.date}
            time={this.props.time}
            onBlur={() => this.props.input.onBlur()}
            inputProps={{
              readOnly: this.props.inputReadOnly || false,
              onClick: this.setDropdownVisibility
            }}
            onToggle={this.setDropdownVisibility}
            open = {this.state.open}
            onChange={this.props.input.onChange}
            value={!this.props.input.value ? null : new Date(this.props.input.value)}
            containerClassName={this.props.className}
          />
        </FormFieldError>
      )
    }
}
